<template>
    <!-- Botão "?" que abre o artigo de ajuda (EngageFacil) em nova aba. Sem slug, não aparece. -->
    <a v-if="slug" :href="url" target="_blank" rel="noopener" class="ajuda-engage-btn"
        :class="['ajuda-engage-' + variante, variante === 'nav' ? 'btn btn-icon-only nav-link' : '']" :title="titulo" :aria-label="titulo" @click.stop>
        <svg xmlns="http://www.w3.org/2000/svg" :width="tamanho" :height="tamanho" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
    </a>
</template>

<script setup>
import { computed } from 'vue';
import { montaUrlAjuda } from '@/config/ajudaEngage';

const props = defineProps({
    // slug do artigo (constante de AJUDA_SLUGS)
    slug: { type: String, default: '' },
    // 'nav' = ícone do cabeçalho; 'popup' = cabeçalho de janela/painel; 'flutuante' = telas sem cabeçalho (login etc.)
    variante: { type: String, default: 'popup' },
    titulo: { type: String, default: 'Ajuda' },
});

const url = computed(() => (props.slug ? montaUrlAjuda(props.slug) : ''));
const tamanho = computed(() => (props.variante === 'nav' ? 22 : 18));
</script>

<style>
/* Estilos globais de propósito: o botão aparece em cabeçalhos, janelas e dropdowns de vários componentes */
.ajuda-engage-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    opacity: 0.7;
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
}
.ajuda-engage-btn:hover,
.ajuda-engage-btn:focus {
    opacity: 1;
    color: inherit;
}
/* Cabeçalho: usa as classes dos ícones vizinhos (btn btn-icon-only nav-link), então herda o mesmo visual */
.ajuda-engage-btn.ajuda-engage-nav {
    opacity: 1;
}
/* Janelas (modal-header): o ? fica logo antes do botão de fechar */
.modal-header .ajuda-engage-popup {
    margin-left: auto;
    margin-right: 0.75rem;
}
.modal-header .ajuda-engage-popup + .btn-close {
    margin-left: 0;
}
/* Telas sem cabeçalho (login, recuperar senha, tela trancada...) */
.ajuda-engage-flutuante {
    position: fixed;
    top: 14px;
    right: 18px;
    z-index: 1100;
    padding: 6px;
    border-radius: 50%;
    background: rgba(128, 128, 128, 0.15);
}
</style>
